import { Modal } from "react-bootstrap";
import yes from "../../assets/yes-icon.png";
import no from "../../assets/no-icon.png";
import deleteIcon from "../../assets/delete-icon.png";
import cancel from "../../assets/cancel-icon.png";
import save from "../../assets/save-icon.png";
import * as Comp from "../../common/CommonComponents";

const ConfirmModal = (props) => {
  let buttonYes = "";
  let buttonNo = "";

  if (props.delete) {
    buttonYes = (
      <Comp.Button type="delete" onClick={props.onConfirm}>
        Delete <img src={deleteIcon} alt="Delete" style={{ width: "20px", height: "20px", marginLeft: "2px", marginBottom: "1px" }} />
      </Comp.Button>
    );
    buttonNo = (
      <Comp.Button id="btnCancel" type="cancel" onClick={props.onHide}>
        Cancel <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "2px" }} />
      </Comp.Button>
    );
  } else if (props.confirm) {
    buttonYes = (
      <Comp.Button type="general" onClick={props.onConfirm}>
        YES <img src={yes} alt="Yes" style={{ width: "22px", height: "22px", marginLeft: "2px", marginBottom: "2px" }} />
      </Comp.Button>
    );
    buttonNo = (
      <Comp.Button id="btnCancel" type="cancel" onClick={props.onHide}>
        NO <img src={no} alt="No" style={{ width: "22px", height: "22px", marginLeft: "2px", marginBottom: "2px" }} />
      </Comp.Button>
    );
  } else if (props.confirmCancel) {
    buttonYes = (
      <Comp.Button type="delete" onClick={props.onConfirm}>
        YES <img src={yes} alt="Yes" style={{ width: "22px", height: "22px", marginLeft: "2px", marginBottom: "2px" }} />
      </Comp.Button>
    );
    buttonNo = (
      <Comp.Button id="btnCancel" type="cancel" onClick={props.onHide}>
        NO <img src={no} alt="No" style={{ width: "22px", height: "22px", marginLeft: "2px", marginBottom: "2px" }} />
      </Comp.Button>
    );
  }
  else {
    buttonYes = (
      <Comp.Button type="general" onClick={props.onConfirm}>
        Save <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
      </Comp.Button>
    );
    buttonNo = (
      <Comp.Button id="btnCancel" type="cancel" onClick={props.onHide}>
        Cancel <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "2px" }} />
      </Comp.Button>
    );
  }

  return (
    <>
      <Modal show={props.show} onHide={props.onHide} centered>
        <Modal.Header>
          <div style={{ backgroundColor: "lightgrey", width: "100%", textAlign: "center" }}>
            <Modal.Title>CONFIRMATION</Modal.Title>
          </div>
        </Modal.Header>
        <div style={{ textAlign: "center" }}>
          <Modal.Body>{props.children}</Modal.Body>
        </div>
        <Modal.Footer>
          <div style={{ textAlign: "center", width: "100%" }}>
            {buttonYes}
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            {buttonNo}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmModal;
